import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, dateColumn, actionEditColumn, statusColumn, imageColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';


export default function P411ListA({ dataTable,onRowClick }) {

    const history = useHistory();
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    onRowClick = {onRowClick}
                    selectionMode="single"
                >


                    <Column field="profilePhotoPath" header="รูป profile" body={(e) => imageColumn(e, 'profilePhotoPath', 'รูป profile')} style={{textAlign: 'center',width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="supervisorName" header="ชื่อ-นามสกุล" body={(e) => normalColumn(e, 'supervisorName', 'ชื่อ-นามสกุล')} style={{ textAlign: 'center'}}  bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="totalContract" header="จำนวนสัญญา"  body={(e) => normalColumn(e, 'totalContract', 'จำนวนสัญญา')} style={{ textAlign: 'center',width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="totalRoute" header="จำนวนเส้นทาง"  body={(e) => normalColumn(e, 'totalRoute', 'จำนวนเส้นทาง')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="totalPipeLength" header="ความยาวรวม (เมตร)"  body={(e) => normalColumn(e, 'totalPipeLength', 'ความยาวรวม(เมตร)')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="totalInspect" header="จำนวนงานที่ตรวจ (ครั้ง)"  body={(e) => normalColumn(e, 'totalInspect', 'จำนวนงานที่ตรวจ(ครั้ง)')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="inspectMobileCount" header="ผ่าน Mobile App (ครั้ง)"  body={(e) => normalColumn(e, 'inspectMobileCount', 'ผ่าน Mobile App(ครั้ง)')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    
                </DataTable>
            </div>
        </div>
    )
}
